import React from "react";
import { Flex, Text } from "@indeed/ifl-components";
import { Avatar, Author, AuthorGroup } from "./articleContent";
import { Grid, GridItem } from "components/grid";
import type { Contributor } from "types/globals";
import type { SystemStyleObject } from "@indeed/ifl-css";

export interface ContributorGroupProps {
  contributorList: Contributor[];
  label: string;
  sx?: SystemStyleObject;
}

export const ContributorGroup: React.FC<ContributorGroupProps> = ({
  contributorList,
  label = "Contributor",
  sx,
}) => (
  <AuthorGroup sx={{ ...sx }}>
    {label && (
      <Text
        sx={{
          color: "neutral.1000",
          fontSize: 3,
          fontWeight: 700,
          lineHeight: "150%",
          display: "block",
          mb: "8px",
        }}
      >
        {label}
      </Text>
    )}
    <Grid
      templateColumns={["1fr", null, "1fr 1fr"]}
      gap={[4, null, 4]}
      sx={{ width: "100%", mb: [2, null, 6] }}
    >
      {contributorList.map(
        ({
          contributorName: name,
          contributorLink: link,
          contributorTitle: title,
          contributorPlaceOfWork: placeOfWork,
          contributorAvatar: avatar,
        }) => (
          <GridItem key={name} colSpan={1}>
            <Flex>
              <Avatar
                avatar={avatar.sourceUrl}
                avatarAltText={avatar.altText}
              />
              <Author
                sx={{
                  lineHeight: 1.25,
                  mb: "8px",
                  fontSize: [4, 4, 4, 6],
                  fontWeight: 700,
                }}
                name={name}
                link={link}
                title={title}
                placeOfWork={placeOfWork}
              />
            </Flex>
          </GridItem>
        )
      )}
    </Grid>
  </AuthorGroup>
);
